import { Shell } from '../../components/layout/shell';
import { NoWarrantyDataState } from '../../components/no-warranty-data-state';
import { useCurrentSystemId } from '../../hooks/use-current-system-id';
import { GetMetricsQuery } from '../../queries/get-metrics';

import { Data } from './components/data';
import { Filters } from './components/filters';
import { Metrics } from './components/metrics';

export function WarrantyPage() {
  const systemId = useCurrentSystemId();
  const metricsQuery = GetMetricsQuery.useQuery({ systemId });

  // Only derive isDataAvailable from settled data — not from stale previous-site data
  const isDataAvailable =
    metricsQuery.isLoading || metricsQuery.isPreviousData
      ? true
      : (metricsQuery.data?.isDataAvailable ?? true);

  if (!isDataAvailable) {
    return (
      <Shell testId="warranty-page">
        <NoWarrantyDataState />
      </Shell>
    );
  }

  return (
    <Shell testId="warranty-page">
      <Filters />
      <Metrics />
      <Data />
    </Shell>
  );
}
